import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

interface Props {
  totalQuestions: number;
  currentQuestionIndex: number;
  isPopupOpen: boolean;
  onActiveBarClick: () => void;
  className?: string;
}

export default function ProjectUsabilityHandsFreeProgressBars({
  totalQuestions,
  currentQuestionIndex,
  isPopupOpen,
  onActiveBarClick,
  className,
}: Props) {
  const t = useTranslations('Usability');

  if (totalQuestions === 0) return null;

  return (
    <div
      className={cn(
        'flex max-w-full min-w-0 items-center gap-0.5 sm:gap-1',
        className
      )}
      data-test='handsfree-progress-bars'
      aria-label={t('questionProgressAria', {
        current: currentQuestionIndex + 1,
        total: totalQuestions,
      })}
    >
      {Array.from({ length: totalQuestions }).map((_, index) => {
        const isActive = index === currentQuestionIndex;
        const questionNumber = index + 1;

        if (isActive) {
          return (
            <button
              key={index}
              onClick={onActiveBarClick}
              className='relative flex h-10 min-w-5 flex-1 flex-col items-center justify-center rounded bg-white transition-all hover:bg-gray-100 sm:h-12 sm:min-w-6'
              aria-label={t('questionProgressActiveAria', {
                current: questionNumber,
                total: totalQuestions,
                action: isPopupOpen ? t('closeAction') : t('openAction'),
              })}
              aria-expanded={isPopupOpen}
              data-test='handsfree-progress-bar-active'
            >
              <span className='truncate px-0.5 text-xs font-semibold text-gray-900 sm:text-sm'>
                {questionNumber}
              </span>
              {isPopupOpen && (
                <div className='absolute -top-2 left-1/2 -translate-x-1/2'>
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    className='size-3 rotate-180 text-white'
                    aria-hidden='true'
                  />
                </div>
              )}
            </button>
          );
        }

        return (
          <div
            key={index}
            className='flex min-w-0 flex-1 justify-center'
            aria-hidden='true'
            data-test='handsfree-progress-bar'
          >
            <div className='h-10 w-1 min-w-px rounded bg-white/25 sm:h-12' />
          </div>
        );
      })}
    </div>
  );
}
